import USER from 'constants/user';

/**
 * In URL the userUsername starts with the prefix '@', so we remove this to
 * be used in specific cases like request params
 */
export const getUserUsernameWithoutPrefix = (userUsername) =>
  userUsername.substring(1);

export const isUserAdmin = (userTypeName) => userTypeName === USER.TYPES.ADMIN;

export const isGenieUser = (userId) => userId === 0;

export const toUsernameWithAtSign = (username) =>
  username ? `@${username}` : null;
